// initial state
const state = {
    items: []
};

// getters
const getters = {};

// actions
const actions = {
    setMenu({ commit }) {
        return new Promise((resolve, reject) => {
            jQuery.ajax({
                type: 'GET',
                url: base_url + 'module/brekz_topmenu/endpoint?desktop=1',
                async: true,
                dataType: 'json',
                success: jsonData => {
                    commit('setMenu', jsonData);
                    resolve();
                }
            });
        });
    }
};

// mutations
const mutations = {
    setMenu(state, menu) {
        state.items = menu;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
